export const LINK_EXPENSIFY = 'link-expensify';
const linkExpensify = () => ({ type: LINK_EXPENSIFY });
export default linkExpensify;
